import { Component } from '@angular/core';
import { DropdownItem } from '../../button/button.component';

@Component({
  selector: 'app-button-showcase',
  templateUrl: './button-showcase.component.html',
  styleUrls: ['./button-showcase.component.scss']
})
export class ButtonShowcaseComponent {
  isLoading = false;
  isDisabled = false;
  isFormValid = true;

  dropdownItems: DropdownItem[] = [
    { label: 'Active Status', value: 'active', checked: true },
    { label: 'Inactive Status', value: 'inactive', checked: false },
    { label: 'Pending Status', value: 'pending', checked: true },
    { label: 'Archived Status', value: 'archived', checked: false }
  ];

  userDropdownItems: DropdownItem[] = [
    { label: 'John Doe', value: 'john_doe', checked: false },
    { label: 'Jane Smith', value: 'jane_smith', checked: false },
    { label: 'Michael Johnson', value: 'michael_johnson', checked: false },
    { label: 'Sarah Williams', value: 'sarah_williams', checked: false },
    { label: 'Robert Brown', value: 'robert_brown', checked: false }
  ];

  selectedUsers: DropdownItem[] = [];

  columnItems: DropdownItem[] = [
    { label: 'ID', value: 'id', checked: true },
    { label: 'Name', value: 'name', checked: true },
    { label: 'Email', value: 'email', checked: true },
    { label: 'Status', value: 'status', checked: false },
    { label: 'Created Date', value: 'created_date', checked: true },
    { label: 'Last Modified', value: 'last_modified', checked: false }
  ];

  statusItems: DropdownItem[] = [
    { label: 'Active', value: 'active', checked: true },
    { label: 'Inactive', value: 'inactive', checked: false },
    { label: 'Pending', value: 'pending', checked: false },
    { label: 'Archived', value: 'archived', checked: false }
  ];

  selectedColumns: DropdownItem[] = [];
  selectedStatuses: DropdownItem[] = [];

  onButtonClick(label: string): void {
    console.log(`Button clicked: ${label}`);
  }

  onDropdownChange(items: DropdownItem[]): void {
    console.log('Dropdown items changed:', items);
  }

  onUserSelectionChange(items: DropdownItem[]): void {
    this.selectedUsers = items;
    console.log('Selected users:', this.selectedUsers);
  }

  confirmSelection(): void {
    console.log('Confirmed selection:', this.selectedUsers);
    alert(`Confirmed ${this.selectedUsers.length} user(s): ${this.selectedUsers.map(u => u.label).join(', ')}`);
  }

  onColumnSelectionChange(items: DropdownItem[]): void {
    this.selectedColumns = items;
    console.log('Selected columns:', this.selectedColumns);
  }

  selectAllColumns(): void {
    this.columnItems.forEach(col => col.checked = true);
    this.selectedColumns = [...this.columnItems];
    console.log('All columns selected');
  }

  resetColumns(): void {
    this.columnItems.forEach(col => col.checked = false);
    this.selectedColumns = [];
    console.log('Columns reset');
  }

  onStatusSelectionChange(items: DropdownItem[]): void {
    this.selectedStatuses = items;
    console.log('Selected statuses:', this.selectedStatuses);
  }

  clearStatusFilters(): void {
    this.statusItems.forEach(status => status.checked = false);
    this.selectedStatuses = [];
    console.log('Status filters cleared');
  }

  toggleLoading(): void {
    this.isLoading = !this.isLoading;
    if (this.isLoading) {
      setTimeout(() => {
        this.isLoading = false;
      }, 2000);
    }
  }

  toggleDisabled(): void {
    this.isDisabled = !this.isDisabled;
  }
}
